"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Menu_1 = __importDefault(require("@material-ui/core/Menu"));
var util_localization_1 = require("@sport-thieme/util-localization");
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var styles_1 = require("@material-ui/core/styles");
var List_1 = require("../../List");
var __1 = require("../..");
var core_1 = require("@material-ui/core");
var ThemeProvider_1 = require("../../ThemeProvider");
function Menu(_a) {
    var username = _a.username, signOut = _a.signOut, anchorEl = _a.anchorEl, onClose = _a.onClose;
    var classes = styles();
    var _b = ThemeProvider_1.useDarkMode(), darkMode = _b[0], setDarkMode = _b[1];
    if (username === undefined || signOut === undefined) {
        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, {}, void 0);
    }
    return (jsx_runtime_1.jsxs(Menu_1.default, __assign({ keepMounted: true, anchorEl: anchorEl, open: Boolean(anchorEl), onClose: onClose, getContentAnchorEl: null, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        } }, { children: [jsx_runtime_1.jsx(MenuItem_1.default, __assign({ className: classes.user, button: false }, { children: username }), void 0),
            jsx_runtime_1.jsxs(MenuItem_1.default, __assign({ onClick: function () { return setDarkMode(!darkMode); } }, { children: [jsx_runtime_1.jsx(List_1.ListItemIcon, { children: darkMode ? jsx_runtime_1.jsx(__1.Icon.Brightness7, {}, void 0) : jsx_runtime_1.jsx(__1.Icon.Brightness4, {}, void 0) }, void 0),
                    jsx_runtime_1.jsx(core_1.Typography, { children: darkMode ? util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Turn off darkmode"], ["Turn off darkmode"]))) : util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["Turn on darkmode"], ["Turn on darkmode"]))) }, void 0)] }), void 0),
            jsx_runtime_1.jsxs(MenuItem_1.default, __assign({ onClick: signOut }, { children: [jsx_runtime_1.jsx(List_1.ListItemIcon, { children: jsx_runtime_1.jsx(__1.Icon.ExitToAppOutlined, {}, void 0) }, void 0),
                    jsx_runtime_1.jsx(core_1.Typography, { children: util_localization_1.localize(templateObject_3 || (templateObject_3 = __makeTemplateObject(["Logout"], ["Logout"]))) }, void 0)] }), void 0)] }), void 0));
}
exports.default = Menu;
var styles = styles_1.makeStyles({
    user: {
        outline: 0,
    },
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Menu.js.map